import { Business } from '@mui/icons-material';
import { Box, Divider, ListItem } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Company } from '/src/lib/models';

export type CompanyInformationProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Company to display information for
   */
  company?: Company;
};

export const CompanyInformation: React.FC<CompanyInformationProps> = ({ company, open, toggleOpen }) => (
  <SidebarItem title="Company Information" open={open} toggleOpen={toggleOpen} resolved={!!company}>
    <ListItem className="pad-top-bottom-xs">
      <Box padding="16px" display="flex" alignItems="center">
        <Business className="md-icon material-icons" sx={{ width: '24px', height: '24px' }} />
      </Box>
      <Box paddingX="16px" display="flex" justifyContent="center" alignItems="start" flex={82} flexDirection="column">
        <Box component="span" className="medium">
          {company?.name}
        </Box>
        <Box component="span">{company?.address.street}</Box>
        <Box>
          <Box component="span">{company?.address.city}</Box>, <Box component="span">{company?.address.state}</Box>{' '}
          <Box component="span">{company?.address.zip}</Box>
        </Box>
      </Box>
    </ListItem>
    {company?.longName && (
      <>
        <Divider />
        <InfoItem title="Long Name" value={company?.longName} smallFont />
      </>
    )}
    <Divider />
    <InfoItem title="Contact Person" value={company?.contactPerson} smallFont />
    <Divider />
    <InfoItem title="Primary Phone" value={company?.phone.primary} smallFont />
    {company?.phone.secondary && <InfoItem title="Secondary Phone" value={company?.phone.secondary} smallFont />}
    {company?.phone.fax && <InfoItem title="Fax" value={company?.phone.fax} smallFont />}
    <Divider />
    <InfoItem title="Email" value={company?.email} url={`mailto:${company?.email}`} smallFont />
    <InfoItem title="Website" value={company?.website} url={company?.website} smallFont />
    <Divider />
    <InfoItem title="Line of Business" value={company?.socketLineOfBusiness ?? ''} capitalize smallFont />
    <InfoItem title="Company Type" value={company?.companyType} smallFont />
    <Divider />
    <InfoItem title="Status" value={company?.status ?? ''} capitalize smallFont />
  </SidebarItem>
);
